const DenHaagHeroThemeImage = (mainclass = '.denhaag-hero--theme-image') => {
  // Elements.
  const imageElement = document?.querySelector( `${mainclass} .denhaag-hero__image` );
  const heroImageElement = document?.querySelector( mainclass );
  const contentElement = document?.querySelector( `${mainclass} .denhaag-hero__content` );


  if (!imageElement) {
    // Early return if no image is found, otherwise `undefinedpx` will be set as height.
    heroImageElement?.style.setProperty( '--denhaag-hero-theme-image-height', `${parseFloat( contentElement?.clientHeight )}px` );
    return;
  }

  // Get realtime element heights.
  const imageElementHeight = parseFloat( imageElement?.clientHeight );
  const contentElementHeight = parseFloat( contentElement?.clientHeight );

  // Set height of heroImageElement.
  if (contentElementHeight > imageElementHeight) {
    const heightDifference = contentElementHeight - imageElementHeight;
    heroImageElement?.style.setProperty(
      '--denhaag-hero-theme-image-height',
      `${imageElementHeight + heightDifference}px`,
    );
  } else {
    heroImageElement?.style.setProperty( '--denhaag-hero-theme-image-height', `${imageElementHeight}px` );
  }
};

export default DenHaagHeroThemeImage;
